import theme from '../../themes/green';

const styles = {
  avatar: {
    borderRadius: '50%',
    backgroundSize: 'cover',
    border: `2px solid ${theme.pallete.color}`,
    marginLeft: 10,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/UserAvatar/styles.js